var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "step_2_off",
    "data-name": "step 2 off",
    transform: "translate(-1016 -162.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176659",
    "data-name": "Group 176659",
    transform: "translate(1016.217 163.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9225",
    "data-name": "Ellipse 9225",
    transform: "translate(-0.217 -0.135)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-credit-card",
    "data-name": "Icon feather-credit-card",
    transform: "translate(1026 175.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4008",
    "data-name": "Path 4008",
    d: "M2.953,6H16.034a1.453,1.453,0,0,1,1.453,1.454v8.721a1.453,1.453,0,0,1-1.453,1.454H2.953A1.453,1.453,0,0,1,1.5,16.175V7.454A1.453,1.453,0,0,1,2.953,6Z",
    transform: "translate(-1.5 -6)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    d: "M1.5,15H17.488",
    transform: "translate(-1.5 -10.639)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.4b1a514872be69a6fda1516c3fbe9ae0.svg";
export { ForwardRef as ReactComponent };